import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { projectsData } from '../data/mock';
import { ExternalLink, Folder } from 'lucide-react';

const ProjectCard = ({ project }) => (
  <Card className="group bg-white border-gray-100 hover:border-gray-200 hover:shadow-md transition-all duration-300">
    <CardContent className="p-6">
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        <div className="p-2 bg-gray-50 rounded-lg">
          <Folder className="w-4 h-4 text-gray-600" />
        </div>
        <ExternalLink className="w-4 h-4 text-gray-300 opacity-0 group-hover:opacity-100 transition-opacity" />
      </div>

      {/* Title */}
      <h3 className="text-lg font-medium text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
        {project.title}
      </h3>

      {/* Description */}
      <p className="text-gray-500 text-sm leading-relaxed mb-4">
        {project.description}
      </p>

      {/* Role */}
      <Badge
        variant="outline"
        className="border-blue-100 text-blue-600 bg-blue-50/50 text-xs font-medium mb-4"
      >
        {project.role}
      </Badge>

      {/* Tech Stack */}
      <div className="flex flex-wrap gap-1.5 pt-4 border-t border-gray-100">
        {project.techStack.map((tech) => (
          <span
            key={tech}
            className="text-xs text-gray-400 font-mono"
          >
            {tech}
          </span>
        ))}
      </div>
    </CardContent>
  </Card>
);

const Projects = () => {
  return (
    <section id="projects" className="py-20 lg:py-28 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-12">
          <span className="text-sm font-medium text-blue-600 tracking-wide uppercase mb-2 block">
            Projects
          </span>
          <h2 className="text-3xl lg:text-4xl font-light text-gray-900 tracking-tight">
            Featured work
          </h2>
          <p className="text-gray-600 mt-3 max-w-xl">
            A selection of projects showcasing my experience across the full stack.
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {projectsData.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
